var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _taggedTemplateLiteral = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _templateObject, _templateObject2, _templateObject3;

var pageResults = require('graph-results-pager');

var _require = require('./../constants'),
    graphAPIEndpoints = _require.graphAPIEndpoints,
    tokenAddresses = _require.tokenAddresses;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require('./wallet'),
    pairsPrices = _require3.pairsPrices,
    pairData = _require3.pairData,
    tokensPrices = _require3.tokensPrices,
    nativeCurrencyDollarValue = _require3.nativeCurrencyDollarValue;

module.exports = {
  info: function info() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$chain_id, chain_id, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$chain_id = _ref.chain_id, chain_id = _ref$chain_id === void 0 ? '100' : _ref$chain_id;

              if (!(graphAPIEndpoints[chain_id].honeyfarm == '')) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", {});

            case 3:
              _context.next = 5;
              return request(graphAPIEndpoints[chain_id].honeyfarm, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    honeyFarms {\n                        ", "\n                    }\n                }"])), _info.properties.toString()));

            case 5:
              result = _context.sent;
              return _context.abrupt("return", _info.callback(result.honeyFarms[0]));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  pools: function pools() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref2, _ref2$chain_id, chain_id;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref2$chain_id = _ref2.chain_id, chain_id = _ref2$chain_id === void 0 ? '100' : _ref2$chain_id;

              if (!(graphAPIEndpoints[chain_id].honeyfarm == '')) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", []);

            case 3:
              return _context2.abrupt("return", pageResults({
                api: graphAPIEndpoints[chain_id].honeyfarm,
                query: {
                  entity: 'pools',
                  properties: _pools.properties
                }
              }).then(function (results) {
                return _pools.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  deposits: function deposits() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref3, _ref3$user_address, user_address, _ref3$chain_id, chain_id, results, pairs, depositsById, pairInfo;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref3$user_address = _ref3.user_address, user_address = _ref3$user_address === void 0 ? undefined : _ref3$user_address, _ref3$chain_id = _ref3.chain_id, chain_id = _ref3$chain_id === void 0 ? '100' : _ref3$chain_id;

              if (!(graphAPIEndpoints[chain_id].honeyfarm == '')) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", []);

            case 3:
              _context3.next = 5;
              return pageResults({
                api: graphAPIEndpoints[chain_id].honeyfarm,
                query: {
                  entity: 'deposits',
                  selection: {
                    where: {
                      user: "\\\"".concat(user_address.toLowerCase(), "\\\""),
                      status: 'Open'
                    }
                  },
                  properties: _deposits.properties
                }
              }).then(function (results) {
                return results;
              }).catch(function (err) {
                return console.log(err);
              });

            case 5:
              results = _context3.sent;
              pairs = [];
              depositsById = {};
              results.forEach(function (deposit) {
                if (!depositsById[deposit.pool.id]) {
                  depositsById[deposit.pool.id] = [];
                }

                depositsById[deposit.pool.id].push(deposit);
                pairs.push(deposit.pool.id.valueOf());
              });
              _context3.next = 11;
              return pairsPrices({
                pairs: pairs,
                chain_id: chain_id
              });

            case 11:
              pairInfo = _context3.sent;
              pairInfo.forEach(function (pair) {
                depositsById[pair.id.toLowerCase()].forEach(function (deposit) {
                  deposit.pairInfo = pair;
                });
              });
              return _context3.abrupt("return", _deposits.callback(results));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  hsfTokens: function hsfTokens() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref4, _ref4$chain_id, chain_id, address, _yield$request, hsfToken;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, _ref4$chain_id = _ref4.chain_id, chain_id = _ref4$chain_id === void 0 ? '100' : _ref4$chain_id;
              address = tokenAddresses[chain_id].comb;
              _context4.next = 4;
              return request(graphAPIEndpoints[chain_id].honeyfarm, gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\tquery hsfToken($id: ID!) {\n\t\t\t\t\thsfToken (id: $id) {\n\t\t\t\t\t\tid,\n\t\t\t\t\t\ttotalSupply,\n\t\t\t\t\t\ttotalHsfHarvested,\n\t\t\t\t\t\ttotalHsfBurned,\n\t\t\t\t\t\ttotalHsfClaimed,\n\t\t\t\t\t\tholders\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t"]))), {
                id: address
              });

            case 4:
              _yield$request = _context4.sent;
              hsfToken = _yield$request.hsfToken;
              return _context4.abrupt("return", hsfToken);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  hsfTokenBurns: function hsfTokenBurns() {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _ref5, _ref5$chain_id, chain_id, offset, now, _yield$request2, hsfTokenBurns, burns;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref5 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, _ref5$chain_id = _ref5.chain_id, chain_id = _ref5$chain_id === void 0 ? '100' : _ref5$chain_id;

              BigInt.prototype.toJSON = function () {
                return this.toString();
              };

              offset = 604800000;
              now = new Date().getMilliseconds() - offset;
              _context5.next = 6;
              return request(graphAPIEndpoints[chain_id].honeyfarm, gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\tquery hsfTokenBurns($time: BigInt) {\n\t\t\t\t\thsfTokenBurns(where: {timestamp_gte: $time}) {\n\t\t\t\t\t\tamount\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t"]))), {
                time: BigInt(now)
              });

            case 6:
              _yield$request2 = _context5.sent;
              hsfTokenBurns = _yield$request2.hsfTokenBurns;
              burns = hsfTokenBurns.reduce(function (a, b) {
                return BigInt(a) + BigInt(b.amount);
              }, 0);
              return _context5.abrupt("return", burns);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  apys: function apys() {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _ref6, _ref6$chain_id, chain_id, info, pools, now, startTime, endTime, from, to, startDistribution, distributionSlope, scale, getHsfInTime, hsfInTime, pairIds, liquidityPositions, liquidityPositionsById, pairPrices, pairsById, nativeCurrencyDollar, combData, combPrice, hsfInDay, hsfScaled, hsfInDayScaled, hsfInYearUsd, hsfInDayUsd, totalAllocPoint, results;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _ref6 = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {}, _ref6$chain_id = _ref6.chain_id, chain_id = _ref6$chain_id === void 0 ? '100' : _ref6$chain_id;
              _context6.next = 3;
              return module.exports.info({
                chain_id: chain_id
              });

            case 3:
              info = _context6.sent;
              _context6.next = 6;
              return module.exports.pools({
                chain_id: chain_id
              });

            case 6:
              pools = _context6.sent;

              if (!(pools === undefined || pools.length === 0)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", []);

            case 9:
              now = Math.floor(new Date().getTime() / 1000);
              startTime = info.startTime.getTime() / 1000;
              endTime = info.endTime.getTime() / 1000;
              from = BigInt(now - startTime);
              to = BigInt(endTime - startTime);
              startDistribution = BigInt(info.startDistribution);
              distributionSlope = BigInt(info.distributionSlope);
              scale = BigInt(info.scale);

              getHsfInTime = function getHsfInTime(from, to) {
                return (to - from) * (2n * startDistribution - distributionSlope * (from + to)) / 2n;
              }; //const hsfInTime = ((to - from) * (2n * startDistribution - (distributionSlope * (from + to)))) / 2n;


              hsfInTime = getHsfInTime(from, to); //get the pool pair addresses and fetch pool data from honeyswap

              poolIds = [];
              pools.forEach(function (pool) {
                return poolIds.push(pool.pair);
              });
              pairIds = [];
              liquidityPositions = [];
              liquidityPositionsById = {};
              pools.forEach(function (pool) {
                pairIds.push(pool.pair);
                var position = {
                  liquidityTokenBalance: pool.balance,
                  address: pool.pair.toLowerCase(),
                  pair: undefined
                };
                liquidityPositionsById[pool.pair.toLowerCase()] = position;
              });
              _context6.next = 27;
              return pairsPrices({
                pairs: pairIds,
                chain_id: chain_id
              });

            case 27:
              pairPrices = _context6.sent;
              pairsById = {};
              pairPrices.forEach(function (pair) {
                var position = liquidityPositionsById[pair.id.toLowerCase()];
                position.pair = pair;
                liquidityPositions.push(position);
                pairsById[pair.id.toLowerCase()] = pair;
              }); // const data = await pairData(liquidityPositions, 'Tulip', chain_id);

              _context6.next = 32;
              return nativeCurrencyDollarValue(chain_id);

            case 32:
              nativeCurrencyDollar = _context6.sent;
              _context6.next = 35;
              return tokensPrices({
                tokens: [tokenAddresses[chain_id].comb],
                chain_id: chain_id
              }).then(function (result) {
                return result[0];
              });

            case 35:
              combData = _context6.sent;
              combPrice = 0;

              if (combData !== undefined) {
                combPrice = combData.derivedNativeCurrency * nativeCurrencyDollar;
              }

              hsfInDay = getHsfInTime(from, from + 3600n * 24n);
              hsfScaled = Number(hsfInTime / scale) / info.scale;
              hsfInDayScaled = Number(hsfInDay / scale) / info.scale;
              hsfInYearUsd = hsfInDayScaled * 365 * combPrice;
              hsfInDayUsd = hsfInDayScaled * combPrice; //filter out pairs that don't exist on honeyswap and remove their allocation

              totalAllocPoint = info.totalAllocPoint;
              results = pools.filter(function (item) {
                var pairInfo = pairsById[item.pair.toLowerCase()];

                if (pairInfo && pairInfo.token0 !== undefined) {
                  return true;
                } else {
                  // totalAllocPoint -= item.allocPoint
                  return false;
                }
              });
              results.forEach(function (pool, index, object) {
                var pairInfo = pairsById[pool.pair.toLowerCase()];
                var poolTotalUSD = pairInfo.reserveUSD / pairInfo.totalSupply * pool.balance;
                var poolHsfInYearUSD = hsfInYearUsd / totalAllocPoint * pool.allocPoint;
                var poolHsfInDayUSD = hsfInDayUsd / totalAllocPoint * pool.allocPoint;
                var averageMultiplier = 1;

                if (pool.totalShares > 0 && pool.balance) {
                  averageMultiplier = pool.totalShares / pool.balance;
                }

                pool.hsfInPool = hsfScaled / totalAllocPoint * pool.allocPoint / averageMultiplier;
                pool.baseApy = 0;
                pool.totalApy = 0;
                pool.pairInfo = pairInfo;
                pool.hsf24h = hsfInDayScaled / totalAllocPoint * pool.allocPoint / averageMultiplier;

                if (poolHsfInYearUSD > 0) {
                  pool.rewardApy = poolHsfInYearUSD / poolTotalUSD * 100 / averageMultiplier;
                } else {
                  pool.rewardApy = 0;
                }

                if (poolHsfInDayUSD > 0) {
                  pool.rewardApy24h = poolHsfInDayUSD / poolTotalUSD * 100 / averageMultiplier;
                } else {
                  pool.rewardApy24h = 0;
                }
              });
              return _context6.abrupt("return", results);

            case 47:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};
var _info = {
  properties: ['id', 'owner', 'startTime', 'endTime', 'minTimeLock', 'maxTimeLock', 'hsf', 'totalHsf', 'totalAllocPoint', 'timeLockMultiplier', 'timeLockConstant', 'startDistribution', 'distributionSlope', 'scale', 'poolCount', 'updatedAt'],
  callback: function callback(results) {
    return {
      id: results.id,
      owner: results.owner,
      startTime: new Date(results.startTime * 1000),
      endTime: new Date(results.endTime * 1000),
      minTimeLock: results.minTimeLock,
      maxTimeLock: results.maxTimeLock,
      hsf: results.hsf,
      totalHsf: results.totalHsf,
      timeLockMultiplier: results.timeLockMultiplier,
      timeLockConstant: results.timeLockConstant,
      startDistribution: results.startDistribution,
      distributionSlope: results.distributionSlope,
      scale: results.scale,
      totalAllocPoint: Number(results.totalAllocPoint),
      poolCount: Number(results.poolCount),
      updatedAt: new Date(results.updatedAt * 1000)
    };
  }
};
var _pools = {
  properties: ['id', 'balance', 'openDepositCount', 'allocPoint', 'lastRewardTimestamp', 'accHsfPerShare', 'totalShares', 'timestamp', 'block', 'updatedAt'],
  callback: function callback(results) {
    return results.map(function (_ref7) {
      var id = _ref7.id,
          balance = _ref7.balance,
          openDepositCount = _ref7.openDepositCount,
          allocPoint = _ref7.allocPoint,
          lastRewardTimestamp = _ref7.lastRewardTimestamp,
          accHsfPerShare = _ref7.accHsfPerShare,
          totalShares = _ref7.totalShares,
          timestamp = _ref7.timestamp,
          block = _ref7.block,
          updatedAt = _ref7.updatedAt;
      return {
        pair: id,
        balance: Number(balance) / 1e18,
        openDepositCount: Number(openDepositCount),
        allocPoint: Number(allocPoint),
        lastRewardTimestamp: new Date(lastRewardTimestamp * 1000),
        accHsfPerShare: Number(accHsfPerShare),
        totalShares: Number(totalShares) / 1e18,
        addedDate: new Date(timestamp * 1000),
        addedBlock: Number(block),
        updatedAt: new Date(updatedAt * 1000)
      };
    });
  }
};
var _deposits = {
  properties: ['id', 'user { id }', 'pool { id }', 'amount', 'rewardDebt', 'unlockTime', 'rewardShare', 'setRewards', 'referrer', 'timestamp', 'block', 'status'],
  callback: function callback(results) {
    return results.map(function (_ref8) {
      var id = _ref8.id,
          user = _ref8.user,
          pool = _ref8.pool,
          amount = _ref8.amount,
          rewardDebt = _ref8.rewardDebt,
          unlockTime = _ref8.unlockTime,
          rewardShare = _ref8.rewardShare,
          setRewards = _ref8.setRewards,
          pairInfo = _ref8.pairInfo,
          referrer = _ref8.referrer,
          timestamp = _ref8.timestamp,
          block = _ref8.block,
          status = _ref8.status;
      return {
        id: id,
        user: user.id,
        pool: pool.id,
        amount: Number(amount) / 1e18,
        rewardDebt: Number(rewardDebt) / 1e18 / 1e18,
        unlockTime: new Date(unlockTime * 1000),
        rewardShare: Number(rewardShare) / 1e18,
        setRewards: Number(setRewards),
        pairInfo: pairInfo,
        referrer: referrer,
        addedDate: new Date(timestamp * 1000),
        addedBlock: Number(block),
        status: status
      };
    });
  }
};